/* Local dependencies */
import { Warehouse } from '../../types';
import {
  CreateWarehouseActionTypes,
  CreateWarehouseError,
  CreateWarehouseInput,
  CreateWarehouseRequest,
  CreateWarehouseSuccess,
  ResetCreateWarehouseError,
  ResetCreateWarehouseState,
} from './types';

export function createWarehouse(input: CreateWarehouseInput): CreateWarehouseRequest {
  return {
    type: CreateWarehouseActionTypes.CREATE_WAREHOUSE,
    input,
  };
}

export function createWarehouseSuccess(warehouse: Warehouse): CreateWarehouseSuccess {
  return {
    type: CreateWarehouseActionTypes.CREATE_WAREHOUSE_SUCCESS,
    warehouse,
  };
}

export function createWarehouseError(error: Error): CreateWarehouseError {
  return {
    type: CreateWarehouseActionTypes.CREATE_WAREHOUSE_ERROR,
    error,
  };
}

export function resetCreateWarehouseError(): ResetCreateWarehouseError {
  return {
    type: CreateWarehouseActionTypes.CREATE_WAREHOUSE_RESET_ERROR,
  };
}

export function resetCreateWarehouseState(): ResetCreateWarehouseState {
  return {
    type: CreateWarehouseActionTypes.CREATE_WAREHOUSE_RESET_STATE,
  };
}
